import { render, staticRenderFns } from "./SolicitudEvento.vue?vue&type=template&id=11024550"
import script from "./SolicitudEvento.vue?vue&type=script&lang=js"
export * from "./SolicitudEvento.vue?vue&type=script&lang=js"
import style0 from "./SolicitudEvento.vue?vue&type=style&index=0&id=11024550&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports